// ENG-015: the one place that decides which analytics channel this client is — used for the
// chat request's client_channel, the /speech/usage event, the /speech/token ?channel= and the
// admin voice kill switch. Mirrors gateway/analytics_channel.py: a widget whose host says it is
// the Genie/Stockton Android app is "genie_widget", any other widget "widget", else "app".

export type ClientChannel = "app" | "widget" | "genie_widget";

const GENIE_SOURCES = new Set(["genie_android", "stockton_android"]);

export const resolveClientChannel = (isWidget: boolean | undefined, hostSource: unknown): ClientChannel => {
    if (!isWidget) {
        return "app";
    }
    const source = String(hostSource || "")
        .trim()
        .toLowerCase();
    return GENIE_SOURCES.has(source) ? "genie_widget" : "widget";
};

// The host source as the widget host set it (ChatWidget.init / setHostContext), read at call time.
export const currentHostSource = (): unknown => {
    try {
        return (window as any)?.PublicWidgetConfig?.hostContext?.source;
    } catch {
        return undefined;
    }
};

type SpeechSwitches = { enabled?: boolean; enabledByChannel?: Partial<Record<ClientChannel, boolean>> } | undefined | null;

// Effective(channel) = enabled && enabledByChannel[channel]; anything missing counts as on
// (an older gateway without the switches must not hide the mic).
export const isVoiceEnabledForChannel = (speech: SpeechSwitches, channel: ClientChannel): boolean =>
    speech?.enabled !== false && speech?.enabledByChannel?.[channel] !== false;
